class PinAvailabilityResult {
    constructor(available, organization, eventId, eventName) {
        this.available = available;
        this.organization = organization;
        this.eventId = eventId;
        this.eventName = eventName;
    }
}

class AltContent {
    constructor(artist, title, lyrics) {
        this.artist = [];
        this.title = [];
        this.lyrics = [];
        this.artist = artist;
        this.title = title;
        this.lyrics = lyrics;
    }
    static fromDto(o) {
        return new AltContent(o.artist, o.title, o.lyrics);
    }
}

class AltLabels {
    constructor(artist, title, lyrics) {
        this.artist = artist;
        this.title = title;
        this.lyrics = lyrics;
    }
    static fromDto(o) {
        return new AltLabels(o.artist || null, o.title || null, o.lyrics || null);
    }
}

class Song {
    constructor(id, artist, title, lyrics, alt, type, ageRange) {
        this.id = id;
        this.artist = artist;
        this.title = title;
        this.lyrics = lyrics;
        this.alt = alt;
        this.type = type;
        this.ageRange = ageRange;
    }
    static fromDto(s) {
        if (!s) {
            return undefined;
        }
        return new Song(s.id, s.artist, s.title, s.lyrics, s.alt ? new AltContent(s.alt.artist, s.alt.title, s.alt.lyrics) : null, s.type, s.ageRange);
    }
}

class Section {
    constructor(type, label, startIndex, endIndex, altLabels) {
        this.type = type;
        this.label = label;
        this.startIndex = startIndex;
        this.endIndex = endIndex;
        this.altLabels = altLabels;
    }
    indices() {
        let indexes = [];
        for (let i = this.startIndex; i < this.endIndex; i++) {
            indexes.push(i);
        }
        return indexes;
    }
    static fromDto(s) {
        return new Section(s.type, s.label, s.startIndex, s.endIndex, s.altLabels);
    }
}

class SetOfBlindtest {
    constructor(sections, songs) {
        this.sections = sections;
        this.songs = songs;
    }
    static fromDto(bs) {
        return new SetOfBlindtest(bs.sections.map((s) => Section.fromDto(s)), bs.songs.map((s) => Song.fromDto(s)));
    }
}

class Blindtest {
    constructor(id, name, description, tags, sets, archived) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.tags = tags;
        this.sets = sets;
        this.archived = archived;
    }
    static fromDto(bt) {
        if (!bt) {
            return undefined;
        }
        return new Blindtest(bt.id, bt.name, bt.description, bt.tags, bt.sets.map(s => SetOfBlindtest.fromDto(s)), bt.archived);
    }
}

class SongImportDescriptor {
    constructor(id, artist, title, lyrics, alt, type, ageRange) {
        this.id = id;
        this.artist = artist;
        this.title = title;
        this.lyrics = lyrics;
        this.alt = alt || null;
        this.type = type;
        this.ageRange = ageRange;
    }
    static fromDto(o) {
        return new SongImportDescriptor(o.id, o.artist, o.title, o.lyrics, o.alt, o.type, o.ageRange);
    }
    static fromSong(o) {
        return new SongImportDescriptor(o.id, o.artist, o.title, o.lyrics, o.alt, o.type, o.ageRange);
    }
    static toSong(o) {
        return new Song(o.id, o.artist, o.title, o.lyrics, o.alt, o.type, o.ageRange);
    }
}

class SectionImportDescriptor {
    constructor(type, altLabels, label, songs) {
        this.type = type;
        this.altLabels = altLabels;
        this.label = label;
        this.songs = songs;
    }
    static fromDto(o) {
        if (!o) {
            throw new Error("error.section.undefined");
        }
        return new SectionImportDescriptor(o.type, AltLabels.fromDto(o.altLabels), o.label, o.songs.map((s) => SongImportDescriptor.fromDto(s)));
    }
    static fromSectionAndSongs(s, songs) {
        return new SectionImportDescriptor(s.type, s.altLabels, s.label, songs.slice(s.startIndex, s.endIndex).map(SongImportDescriptor.fromSong));
    }
}

class SetOfBlindtestImportDescriptor {
    constructor(sections) {
        this.sections = sections;
    }
    static toSetOfBlindtest(o) {
        let startIndex = 0;
        const sections = [];
        const songs = [];
        for (let i in o.sections) {
            let section = o.sections[i];
            sections.push(new Section(section.type, section.label, startIndex, startIndex + section.songs.length, section.altLabels));
            startIndex += section.songs.length;
            songs.push(...section.songs.map(s => SongImportDescriptor.toSong(s)));
        }
        return new SetOfBlindtest(sections, songs);
    }
    static fromSetOfBlindtest(set) {
        const sections = [];
        set.sections.forEach(section => {
            sections.push(SectionImportDescriptor.fromSectionAndSongs(section, set.songs));
        });
        return new SetOfBlindtestImportDescriptor(sections);
    }
    static fromDto(o) {
        return new SetOfBlindtestImportDescriptor(o.sections.map((s) => SectionImportDescriptor.fromDto(s)));
    }
}

class BlindtestImportDescriptor {
    constructor(id, name, tags, sets, archived, description) {
        this.id = id;
        this.name = name;
        this.tags = tags;
        this.sets = sets;
        this.archived = archived;
        this.description = description;
    }
    static fromBlindtest(o) {
        return new BlindtestImportDescriptor(o.id, o.name, o.tags, o.sets.map((s) => SetOfBlindtestImportDescriptor.fromSetOfBlindtest(s)), o.archived, o.description);
    }
    static fromDto(o) {
        return new BlindtestImportDescriptor(o.id, o.name, o.tags, o.sets.map((s) => SetOfBlindtestImportDescriptor.fromDto(s)), o.archived, o.description);
    }
    static toBlindtest(o) {
        return new Blindtest(o.id, o.name, o.description, o.tags, o.sets.map((s) => SetOfBlindtestImportDescriptor.toSetOfBlindtest(s)), o.archived);
    }
}

var SongType;
(function (SongType) {
    SongType[SongType["NORMAL"] = 0] = "NORMAL";
    SongType[SongType["LYRICS"] = 1] = "LYRICS";
})(SongType || (SongType = {}));

class BlindtestCreationSectionDto {
}
class BlindtestCreationSetDto {
}
class BlindtestCreationDescriptor {
}

var SetOfBlindtestStatus;
(function (SetOfBlindtestStatus) {
    SetOfBlindtestStatus[SetOfBlindtestStatus["READY"] = 0] = "READY";
    SetOfBlindtestStatus[SetOfBlindtestStatus["ONGOING"] = 1] = "ONGOING";
    SetOfBlindtestStatus[SetOfBlindtestStatus["PAUSED"] = 2] = "PAUSED";
    SetOfBlindtestStatus[SetOfBlindtestStatus["FINISHED"] = 3] = "FINISHED";
})(SetOfBlindtestStatus || (SetOfBlindtestStatus = {}));

class BlindtestControl {
    constructor(setCount = 0, current = 0, status = SetOfBlindtestStatus.READY, showLeaderboard = false, enableJokers = false, lockPlayers = false, scores = new Map()) {
        this.status = status;
        this.current = current;
        this.setCount = setCount;
        this.showLeaderboard = showLeaderboard;
        this.enableJokers = enableJokers;
        this.scores = scores;
        this.lockPlayers = lockPlayers;
    }
    isRunning() {
        return this.status === SetOfBlindtestStatus.ONGOING || this.status === SetOfBlindtestStatus.PAUSED;
    }
    static fromDto(o) {
        if (!o) {
            return undefined;
        }
        return new BlindtestControl(o.setCount, o.current, o.status, o.showLeaderboard, o.enableJokers, o.lockPlayers, o.scores);
    }
}

class Branding {
}

class BrandingDescriptor {
    constructor(label, logo, logoCorner) {
        this.label = label;
        this.logo = logo;
        this.logoCorner = logoCorner;
    }
}

class SetControl {
    constructor(songCount = 0, current = 0, currentSongId, status = SetOfBlindtestStatus.READY, previouslyPlayed = []) {
        this.songCount = songCount;
        this.status = status;
        this.currentSongId = currentSongId || null;
        this.current = current;
        this.previouslyPlayed = previouslyPlayed;
    }
    isRunning() {
        return this.status === SetOfBlindtestStatus.ONGOING || this.status === SetOfBlindtestStatus.PAUSED;
    }
    static fromDto(o) {
        if (!o) {
            return undefined;
        }
        return new SetControl(o.songCount, o.current, o.currentSongId, o.status, o.previouslyPlayed);
    }
}

class SectionControl {
    constructor(size = 0, position = 0, sectionCount = 0, current = 0) {
        this.size = size;
        this.position = position;
        this.sectionCount = sectionCount;
        this.current = current;
    }
    static fromDto(o) {
        if (!o) {
            return undefined;
        }
        return new SectionControl(o.size, o.position, o.sectionCount, o.current);
    }
}

class StatsForSong {
    constructor(answeredPlayers, responsePercent, failurePercent, partialSuccessPercent, successPercent, fastestPlayerResult, slowestPlayerResult, fastestPlayer, slowestPlayer, soleWinner, soleLoser) {
        this.answeredPlayers = answeredPlayers;
        this.responsePercent = Math.floor(responsePercent);
        this.failurePercent = Math.floor(this.failurePercent) || 0;
        this.partialSuccessPercent = Math.floor(this.partialSuccessPercent) || 0;
        this.successPercent = Math.floor(successPercent) || 0;
        this.fastestPlayer = fastestPlayer;
        this.fastestPlayerResult = fastestPlayerResult;
        this.slowestPlayer = slowestPlayer;
        this.slowestPlayerResult = slowestPlayerResult;
        this.soleWinner = soleWinner;
        this.soleLoser = soleLoser;
    }
    static fromDto(o) {
        if (!o) {
            return undefined;
        }
        return new StatsForSong(o.answeredPlayers, o.responsePercent, o.failurePercent, o.partialSuccessPercent, o.successPercent, o.fastestPlayerResult, o.slowestPlayerResult, o.fastestPlayer, o.slowestPlayer, o.soleWinner, o.soleLoser);
    }
}

class SongControl {
    constructor(locked = false, revealed = false, computingStats = false, computingResults = false, stats = null, answer = null) {
        this.locked = locked;
        this.revealed = revealed;
        this.computingStats = computingStats;
        this.computingResults = computingResults;
        this.stats = stats;
        this.answer = answer;
    }
    static fromDto(o) {
        if (!o) {
            return undefined;
        }
        return new SongControl(o.locked, o.revealed, o.computingStats, o.computingResults, StatsForSong.fromDto(o.stats), Song.fromDto(o.answer));
    }
}

class GameControls {
    constructor(blindtestControl, setControl, sectionControl, songControl) {
        this.blindtestControl = blindtestControl;
        this.setControl = setControl;
        this.sectionControl = sectionControl;
        this.songControl = songControl;
    }
    static fromDto(gs) {
        if (!gs) {
            return undefined;
        }
        return new GameControls(BlindtestControl.fromDto(gs.blindtestControl), SetControl.fromDto(gs.setControl), SectionControl.fromDto(gs.sectionControl), SongControl.fromDto(gs.songControl));
    }
    isRunning() {
        return this.blindtestControl && (this.blindtestControl.status === SetOfBlindtestStatus.ONGOING || this.blindtestControl.status === SetOfBlindtestStatus.PAUSED);
    }
    isFinished() {
        return this.blindtestControl && (this.blindtestControl.status === SetOfBlindtestStatus.FINISHED);
    }
}

class GameMetadata {
    constructor(id, organization, pin, name, blindtestId, demo, test, demoTeamCap, scoreStrategy, playerNamingStrategy, servicesEnabled, services, feedbackFormEnabled, ageRanges, lang, branding, permalink, permalinkId, managedExternally, externalSessionId, jokers) {
        this.id = id;
        this.organization = organization;
        this.pin = pin;
        this.name = name;
        this.blindtestId = blindtestId;
        this.demo = demo;
        this.test = test;
        this.demoTeamCap = demoTeamCap;
        this.scoreStrategy = scoreStrategy;
        this.playerNamingStrategy = playerNamingStrategy;
        this.servicesEnabled = servicesEnabled;
        this.services = services;
        this.feedbackFormEnabled = feedbackFormEnabled;
        this.ageRanges = ageRanges;
        this.lang = lang;
        this.branding = branding;
        this.permalink = permalink;
        this.permalinkId = permalinkId;
        this.managedExternally = managedExternally;
        this.externalSessionId = externalSessionId;
        this.jokers = jokers;
    }
    static fromDto(o) {
        if (!o) {
            return undefined;
        }
        return new GameMetadata(o.id, o.organization, o.pin, o.name, o.blindtestId, o.demo, o.test, o.demoTeamCap, o.scoreStrategy, o.playerNamingStrategy, o.servicesEnabled, o.services, o.feedbackFormEnabled, o.ageRanges, o.lang, o.branding, o.permalink, o.permalinkId, o.managedExternally, o.externalSessionId, o.jokers);
    }
}

class Game {
    constructor(metadata, blindtest, control) {
        this.metadata = metadata;
        this.blindtest = blindtest;
        this.control = control;
    }
    static fromDto(o) {
        if (!o) {
            return undefined;
        }
        return new Game(GameMetadata.fromDto(o.metadata), Blindtest.fromDto(o.blindtest), GameControls.fromDto(o.control));
    }
}

class GameDescriptor {
    constructor(blindtestId, managedExternally, name, demo, test, services, ageRanges, lang, pin, playerNamingStrategy, gameplay, jokers, slug, enableFeedbackForm, branding) {
        this.managedExternally = false;
        this.blindtestId = blindtestId;
        this.managedExternally = managedExternally;
        this.name = name;
        this.demo = demo;
        this.test = test;
        this.services = services;
        this.ageRanges = ageRanges;
        this.lang = lang;
        this.pin = pin;
        this.playerNamingStrategy = playerNamingStrategy;
        this.gameplay = gameplay;
        this.jokers = jokers;
        this.slug = slug;
        this.enableFeedbackForm = enableFeedbackForm;
        this.branding = branding;
    }
}

class SongPreviouslyPlayed {
    constructor(song, stats) {
        this.song = song;
        this.stats = stats;
    }
}

class AttachedFile {
    constructor(blob, mimeType, filename) {
        this.blob = blob;
        this.mimeType = mimeType;
        this.filename = filename;
    }
}

class LeaderboardEntry {
    constructor(player, position, score) {
        this.player = player;
        this.position = position;
        this.score = score;
    }
}

class ServiceLeaderboardEntry {
    constructor(name, playerCount, score) {
        this.name = name;
        this.playerCount = playerCount;
        this.score = score;
    }
}

class Player {
    constructor(id, name, avatar, creationDate, service) {
        this.id = id;
        this.name = name;
        this.avatar = avatar;
        this.creationDate = creationDate;
        this.service = service || null;
    }
}

class PlayerMetadata {
    constructor(id, name, normalizedName, avatar, creationDate, members) {
        this.id = id;
        this.name = name;
        this.normalizedName = normalizedName;
        this.avatar = avatar;
        this.creationDate = creationDate;
        this.members = members;
    }
}

var PlayerNamingStrategy;
(function (PlayerNamingStrategy) {
    PlayerNamingStrategy.PLAYER_NAME = 'playerName';
    PlayerNamingStrategy.FULL_NAME = 'fullName';
    PlayerNamingStrategy.EMAIL = 'email';
})(PlayerNamingStrategy || (PlayerNamingStrategy = {}));

var Bonus;
(function (Bonus) {
    Bonus[Bonus["None"] = 0] = "None";
    Bonus[Bonus["FastestToAnswer"] = 1] = "FastestToAnswer";
    Bonus[Bonus["JokerSuccess"] = 2] = "JokerSuccess";
})(Bonus || (Bonus = {}));

var Gameplay;
(function (Gameplay) {
    Gameplay[Gameplay["ClassicPerSet"] = 0] = "ClassicPerSet";
    Gameplay[Gameplay["FasterStrongerPerSet"] = 1] = "FasterStrongerPerSet";
})(Gameplay || (Gameplay = {}));
(function (Gameplay) {
    function values() {
        return [
            { name: 'Classic', description: 'les scores sont calculés et ajoutés à chaque chanson (un point par bonne réponse). Remis à zéro entre chaque série.', value: Gameplay.ClassicPerSet },
            { name: 'Faster Stronger', description: 'Plus vous répondez vite, plus vous avez de points (entre 25 et 50 points par bonne réponse). Les scores sont remis à zéro entre chaque série.', value: Gameplay.FasterStrongerPerSet }
        ];
    }
    Gameplay.values = values;
    function name(g) {
        switch (g) {
            case Gameplay.ClassicPerSet:
                return 'Classic';
            case Gameplay.FasterStrongerPerSet:
                return 'Faster Stronger';
        }
        return null;
    }
    Gameplay.name = name;
})(Gameplay || (Gameplay = {}));

var Joker;
(function (Joker) {
    Joker[Joker["DoubleOrNothing"] = 1] = "DoubleOrNothing";
    Joker[Joker["Spy"] = 2] = "Spy";
    Joker[Joker["MindReader"] = 4] = "MindReader";
})(Joker || (Joker = {}));
(function (Joker) {
    function values() {
        return [
            { name: 'Quitte ou double', hasTarget: false, description: 'Si tu as tout juste à cette chanson, les points gagnés pour cette chanson seront doublés.\r\n\r\nPar contre, faire ne serait-ce qu\'une erreur entrainerait un beau zéro pointé.\r\n', image: '/assets/imgs/double-or-nothing.png', value: Joker.DoubleOrNothing },
            { name: 'Espion', hasTarget: true, description: 'Choisis un autre joueur et sa réponse sera copiée à la place de la tienne.\r\n\r\nSi l\'autre joueur ne répond pas, ta réponse sera quand même prise en compte.\r\nAttention, il faut quand même que tu soumettes une réponse!', image: '/assets/imgs/spy.png', value: Joker.Spy },
            { name: 'Mind Reader', hasTarget: false, description: 'Tu n\'es pas sur du titre ou de l\'artiste?\r\nCe Joker te remplacera une faute par la vraie valeur.\r\n\r\nNi vu, ni connu.\r\nTu pourras même faire comme si tu connaissais la réponse depuis le début.', image: '/assets/imgs/mind-reader.png', value: Joker.MindReader }
        ];
    }
    Joker.values = values;
    function getFromMask(mask) {
        return values().filter(v => (mask & v.value) == v.value);
    }
    Joker.getFromMask = getFromMask;
    function name(j) {
        switch (j) {
            case Joker.DoubleOrNothing:
                return 'Quitte ou double';
            case Joker.Spy:
                return 'Espion';
            case Joker.MindReader:
                return 'Mind Reader';
        }
        return null;
    }
    Joker.name = name;
})(Joker || (Joker = {}));

class JokerSubmission {
    constructor(playerId, joker, targetPlayerId) {
        this.playerId = playerId;
        this.joker = joker;
        this.targetPlayerId = targetPlayerId || null;
    }
}

var Malus;
(function (Malus) {
    Malus[Malus["None"] = 0] = "None";
    Malus[Malus["SlowestToAnswer"] = 1] = "SlowestToAnswer";
    Malus[Malus["JokerFailure"] = 2] = "JokerFailure";
})(Malus || (Malus = {}));

class SongPendingReview {
}

class SongResult {
    constructor(songId, playerId, submission, review, score, result) {
        this.songId = songId || null;
        this.playerId = playerId || null;
        this.submission = submission;
        this.review = review;
        this.score = score;
        this.result = result;
    }
}

var MatchResult;
(function (MatchResult) {
    MatchResult[MatchResult["Incorrect"] = 0] = "Incorrect";
    MatchResult[MatchResult["Correct"] = 1] = "Correct";
    MatchResult[MatchResult["Unsolved"] = 2] = "Unsolved";
})(MatchResult || (MatchResult = {}));
class SongReview {
    isSolved() {
        switch (this.type) {
            case SongType.NORMAL:
                return this.artist !== MatchResult.Unsolved && this.title !== MatchResult.Unsolved;
            case SongType.LYRICS:
                return this.lyrics !== MatchResult.Unsolved;
        }
    }
}

class SongSubmission {
    constructor(id, index, playerId, artist, title, lyrics, type, position = -1, answeringTimeInSeconds = -1) {
        this.id = id;
        this.index = index;
        this.playerId = playerId;
        this.artist = artist;
        this.title = title;
        this.lyrics = lyrics;
        this.type = type;
        this.position = position;
        this.answeringTimeInSeconds = answeringTimeInSeconds;
    }
}

function mapEnvironmentToShowtimeConfig(organization, lang, env, ids) {
    const blobs = [];
    let newIds = ids;
    if (!newIds) {
        newIds = {};
    }
    const media = env.showtime.media;
    media.forEach(m => {
        blobs.push({
            key: m.key,
            lang: m.lang,
            type: m.type,
            link: m.link,
            duration: m.duration,
            elementId: newIds[m.key].id
        });
    });
    return {
        organization: organization,
        lang: lang,
        blobs: blobs
    };
}

class ShowtimeControl {
    constructor(showtime, currentlyOnScreen, mediaState = null, backtrackMuted = true, backtrackVolume = 0.1) {
        this.showtime = showtime || null;
        this.currentlyOnScreen = currentlyOnScreen || null;
        this.mediaState = mediaState;
        this.backtrackMuted = backtrackMuted;
        this.backtrackVolume = backtrackVolume;
    }
    isVideoShowing() {
        return this.currentlyOnScreen !== null;
    }
    getShowtimeAsDate() {
        if (!this.showtime) {
            return null;
        }
        return new Date(this.showtime);
    }
    isCountdownShowing() {
        return this.currentlyOnScreen && this.currentlyOnScreen === 'countdown' || this.currentlyOnScreen === 'countdown-override';
    }
    isCountdownOverrideShowing() {
        return this.currentlyOnScreen && this.currentlyOnScreen === 'countdown-override';
    }
}

class ShowtimeMetadata {
    constructor(active, lang) {
        this.active = active;
        this.lang = lang;
    }
}

class ShowtimeSettings {
}

var MediaPlayState;
(function (MediaPlayState) {
    MediaPlayState["START"] = "start";
    MediaPlayState["PLAYING"] = "playing";
    MediaPlayState["PAUSE"] = "pause";
    MediaPlayState["PAUSED"] = "paused";
    MediaPlayState["RESUME"] = "resume";
    MediaPlayState["FORWARD"] = "forward";
    MediaPlayState["BACKWARD"] = "backward";
    MediaPlayState["ENDING"] = "ending";
    MediaPlayState["END"] = "end";
    MediaPlayState["STOP_IMMEDIATELY"] = "stop-immediately";
    MediaPlayState["NONE"] = "none";
})(MediaPlayState || (MediaPlayState = {}));

function assertNotEmpty(str) {
    if (!notEmpty(str)) {
        throw new Error('error.empty');
    }
}
function notEmpty(str) {
    return str?.trim()?.length > 0;
}

/**
 * Generated bundle index. Do not edit.
 */

export { AltContent, AltLabels, AttachedFile, Blindtest, BlindtestControl, BlindtestCreationDescriptor, BlindtestCreationSectionDto, BlindtestCreationSetDto, BlindtestImportDescriptor, Bonus, Branding, BrandingDescriptor, Game, GameControls, GameDescriptor, GameMetadata, Gameplay, Joker, JokerSubmission, LeaderboardEntry, Malus, MatchResult, MediaPlayState, PinAvailabilityResult, Player, PlayerMetadata, PlayerNamingStrategy, Section, SectionControl, SectionImportDescriptor, ServiceLeaderboardEntry, SetControl, SetOfBlindtest, SetOfBlindtestImportDescriptor, SetOfBlindtestStatus, ShowtimeControl, ShowtimeMetadata, ShowtimeSettings, Song, SongControl, SongImportDescriptor, SongPendingReview, SongPreviouslyPlayed, SongResult, SongReview, SongSubmission, SongType, StatsForSong, assertNotEmpty, mapEnvironmentToShowtimeConfig, notEmpty };
